import PropTypes, {InferProps} from "prop-types";
import {profileList, useProfile} from "@betrue/front/services";
import {Profile} from "@betrue/shared/interfaces";
import {useEffect} from "react";
import {PublicProfilesView} from "./public-profiles.view";

export const PublicProfilesPropsTypes = {
  noProfilesLabel: PropTypes.string

}
export type PublicProfilesProps = InferProps<typeof PublicProfilesPropsTypes>

export const PublicProfiles = (props: PublicProfilesProps) => {

  const [publicProfiles, {getPublicProfiles}] = useProfile<Profile[]>(profileList)

  useEffect(() => {
    getPublicProfiles()
  }, [])


  if (!publicProfiles) return (<></>)

  return (<PublicProfilesView {...props} profiles={publicProfiles}/>);
}

PublicProfiles.propTypes = PublicProfilesPropsTypes
